import { HttpClient } from "./api.helper";

import * as url from "./url.helper";

const api = new HttpClient();

//#region AUTH
export const signin = (data) => api.create(url.AUTH_SIGNIN, data);

export const forgotPassword = (data) =>
  api.patch(url.AUTH_FORGOT_PASSWORD, data);

export const changeUserPassword = (data) =>
  api.patch(url.USER_CHANGE_PASSWORD, data);

export const resetUserPassword = (data) =>
  api.patch(`${url.AUTH_RESET_PASSWORD}/${data.token}`, data);

//#endregion

//#region Settings/ Profile

export const getUserProfile = () => api.get(url.USER_GET_PROFILE);

export const updateUserProfile = (data) =>
  api.patch(url.USER_GET_PROFILE, data);

export const updateProfileAvatarAPI = (data) =>
  api.uploadFile(url.UPDATE_PROFILE_AVATAR, data);

//#endregion

//#region Customers

export const getCustomersAPI = (data) => api.get(url.GET_CUSTOMERS(data));

export const addCustomerAPI = (data) => api.create(`${url.ADD_CUSTOMER}`, data);

export const getCustomerAPI = (id) => api.get(url.GET_CUSTOMER(id));

export const updateCustomerAPI = (data) =>
  api.patch(`${url.UPDATE_CUSTOMER(data.id)}`, data);

export const deleteUserAPI = (id) => api.delete(`${url.DELETE_USER(id)}`);

//#endregion

//#region Technicians

export const getTechniciansAPI = (data) => api.get(url.GET_TECHNICIANS(data));

export const addTechnicianAPI = (data) =>
  api.create(`${url.ADD_TECHNICIAN}`, data);

export const getTechnicianAPI = (id) => api.get(url.GET_TECHNICIAN(id));

export const updateTechnicianAPI = (data) =>
  api.patch(`${url.UPDATE_TECHNICIAN(data.id)}`, data);

export const deleteTechnicianAPI = (id) => api.delete(`${url.DELETE_USER(id)}`);

export const updateBlockStatusAPI = (data) =>
  api.create(`${url.UPDATE_BLOCK_STATUS(data.id)}`, data);

//#endregion

//#region Categories

export const getCategoriesAPI = (data) => api.get(url.GET_CATEGORIES(data));

export const addCategoryAPI = (data) => api.create(`${url.ADD_CATEGORY}`, data);

export const getCategoryAPI = (id) => api.get(url.GET_CATEGORY(id));

export const updateCategoryAPI = (data) =>
  api.patch(`${url.UPDATE_CATEGORY(data.id)}`, data);

export const deleteCategoryAPI = (id) =>
  api.delete(`${url.DELETE_CATEGORY(id)}`);

export const uploadCategoryIconAPI = (data) =>
  api.uploadFile(`${url.UPLOAD_CATEGORY_ICON}`, data);

export const getCategoriesSelectListAPI = () =>
  api.get(url.GET_CATEGORIES_SELECT_LIST);

export const getTechnicianPurchasesAPI = (id) =>
  api.get(url.GET_TECHNICIAN_PURCHASES(id));

export const changeTechnicianRemainingCallsAPI = (request) =>
  api.patch(url.CHANGE_TECHNICIAN_REMAINING_CALLS, request);
//#endregion

//#region Services

export const getServicesAPI = (data) => api.get(url.GET_SERVICES(data));

export const addServiceAPI = (data) => api.create(`${url.ADD_SERVICE}`, data);

export const getServiceAPI = (id) => api.get(url.GET_SERVICE(id));

export const updateServiceAPI = (data) =>
  api.patch(`${url.UPDATE_SERVICE(data.id)}`, data);

export const deleteServiceAPI = (id) => api.delete(`${url.DELETE_SERVICE(id)}`);

export const uploadServiceIconAPI = (data) =>
  api.uploadFile(`${url.UPLOAD_SERVICE_ICON}`, data);

//#endregion

//#region Governorates

export const getGovernoratesAPI = (data) => api.get(url.GET_GOVERNORATES(data));

export const addGovernorateAPI = (data) =>
  api.create(`${url.ADD_GOVERNORATE}`, data);

export const getGovernorateAPI = (id) => api.get(url.GET_GOVERNORATE(id));

export const updateGovernorateAPI = (data) =>
  api.patch(`${url.UPDATE_GOVERNORATE(data.id)}`, data);

export const deleteGovernorateAPI = (id) =>
  api.delete(`${url.DELETE_GOVERNORATE(id)}`);

export const getGovernoratesSelectListAPI = () =>
  api.get(url.GET_GOVERNORATES_SELECT_LIST);

//#endregion

//#region Cities

export const getCitiesAPI = (data) => api.get(url.GET_CITIES(data));

export const addCityAPI = (data) => api.create(`${url.ADD_CITY}`, data);

export const getCityAPI = (id) => api.get(url.GET_CITY(id));

export const updateCityAPI = (data) =>
  api.patch(`${url.UPDATE_CITY(data.id)}`, data);

export const deleteCityAPI = (id) => api.delete(`${url.DELETE_CITY(id)}`);

//#endregion

//#region Notifications

export const sendNotificationAPI = (data) =>
  api.create(url.SEND_NOTIFICATION(data), data);

export const sendNotificationV2API = (data) =>
  api.create(url.SEND_NOTIFICATION_V2(data), data);

//#endregion

//#region Dashboard Data

export const getDashboardDataAPI = () => api.get(url.GET_DASHBOARD_DATA);

//#endregion

//#region Ad Data

export const getAdsAPI = (data) => api.get(url.GET_ADS(data));

export const addAdAPI = (data) => api.create(`${url.ADD_AD}`, data);

export const getAdAPI = (id) => api.get(url.GET_AD(id));

export const updateAdAPI = (data) =>
  api.patch(`${url.UPDATE_AD(data.id)}`, data);

export const deleteAdAPI = (id) => api.delete(`${url.DELETE_AD(id)}`);

export const uploadAdBannerAPI = (data) =>
  api.uploadFile(url.UPLOAD_AD_BANNER, data);
//#endregion

//#region Complains

export const getComplainsAPI = (data) => api.get(url.GET_COMPLAINS(data));

export const getComplainAPI = (id) => api.get(url.GET_COMPLAIN(id));

export const sendComplainReplyAPI = (data) =>
  api.create(url.SEND_COMPLAIN_REPLY(data.complainId), data);

//#endregion

//#region Orders

export const getOrdersAPI = (data) => api.get(url.GET_ORDERS(data));

export const getOrderAPI = (id) => api.get(url.GET_ORDER(id));

export const getOrderHistoryAPI = (id) => api.get(url.GET_ORDER_HISTORY(id));

//#endregion

//#region Policies

export const getPoliciesAPI = (data) => api.get(url.GET_POLICIES(data));

export const addPolicyAPI = (data) => api.create(`${url.ADD_POLICY}`, data);

export const getPolicyAPI = (id) => api.get(url.GET_POLICY(id));

export const updatePolicyAPI = (data) =>
  api.patch(`${url.UPDATE_POLICY(data.id)}`, data);

export const deletePolicyAPI = (id) => api.delete(`${url.DELETE_POLICY(id)}`);

export const getDefaultPolicyAPI = () => api.get(url.GET_DEFAULT_POLICY());

export const sendContactUsMessageAPI = (data) =>
  api.create(`${url.CONTACT_US}`, data);

export const sendDeleteAccountRequestAPI = (data) =>
  api.create(`${url.DELETE_ACCOUNT_REQUEST}`, data);

//#endregion

//#region Settings

export const getSettingsAPI = () => api.get(url.GET_SETTINGS());

export const updateSettingsAPI = (data) =>
  api.patch(`${url.UPDATE_SETTINGS()}`, data);

//#endregion

//#region dashboard
export const getDashboardAPI = (data) => api.get(url.GET_DASHBOARD(data));

//#endregion

//#region purchases

export const getSubscriptionsAPI = (data) =>
  api.get(url.GET_SUBSCRIPTIONS(data));

export const getSubscriptionAPI = (id) => api.get(url.GET_SUBSCRIPTION(id));

export const updateSubscriptionAPI = (data) =>
  api.patch(`${url.UPDATE_SUBSCRIPTION(data)}`);

//#endregion
